(function SetupFlexgridServiceScope(angular, wijmo) {
    'use strict';

    angular.module('onvio.reports')
        .factory('onvio.reports.setupFlexgridService', setupFlexgridService);

    setupFlexgridService.$inject = ['flexGridSetUpService', '$window'];

    function setupFlexgridService(flexGridSetUpService, $window) {
        var service = {};
        var flexgridConstants = {
            Height: {
                Headers: 48,
                Columns: 37,
                Invisible: 0
            }
        };

        // Atributes
        service.grid = undefined;
        service.ctx = undefined;

        // Functions
        service.initData = initData;
        service.changeDefaultGridSize = changeDefaultGridSize;
        service.setUpColumnVisibility = setUpColumnVisibility;
        service.createFilterColumns = createFilterColumns;
        service.hideShowColumnsFilter = hideShowColumnsFilter;
        service.onSortingColumn = onSortingColumn;
        service.sortColumns = sortColumns;
        service.toggleColumnsFilter = toggleColumnsFilter;

        function initData(grid, ctx, $scope) {
            // Allow access to those properties
            service.grid = grid;
            service.ctx = ctx;
            $scope.ctx = {
                flexGrid: ctx.flexgrid
            };
        }

        function changeDefaultGridSize() {
            // Change default size of grid lines
            service.grid.rows.defaultSize = flexgridConstants.Height.Columns;
            service.grid.columnHeaders.rows.defaultSize = flexgridConstants.Height.Headers;
        }

        function setUpColumnVisibility() {
            var colVisObj = flexGridSetUpService.setUpColumnVisibility(service.grid, service.ctx.columnsToToggle);
            service.ctx.columnVis = colVisObj.columnVis;
        }

        function createFilterColumns() {
            var rowA = new wijmo.grid.Row();
            var rowB = new wijmo.grid.Row();

            service.grid.columnHeaders.rows.insert(0, rowA);
            service.grid.columnHeaders.rows.insert(0, rowB);
            service.grid.columnHeaders.rows[0].height = flexgridConstants.Height.Headers;
            service.grid.columnHeaders.rows[2].height = flexgridConstants.Height.Invisible;
            service.ctx.flexgrid.onSortingColumn = service.onSortingColumn;
        }

        function hideShowColumnsFilter() {
            /*jshint validthis:true */
            this.toggleColumnsFilter(service.ctx);
        }

        function toggleColumnsFilter(ctx) {
            ctx.flexgrid.columnHeaders.rows[1].height = ctx.filtersHidden ? flexgridConstants.Height.Invisible : flexgridConstants.Height.Headers;
        }

        function onSortingColumn(e) {
            if (e.row === 0) {
                sortColumns();

            } else {
                e.cancel = true;
            }
            return !e.cancel;
        }

        function sortColumns() {
            service.ctx.source.sortConverter = function(sd, _item, value) {
                if (sd.property === 'publicationDate' || sd.property === 'viewDate') {
                    const date = value.split(' ')[0];
                    const hour = value.split(' ')[1];
                    const year = date.split('/')[2];
                    const month = date.split('/')[1];
                    const day = date.split('/')[0];
                    const finalDate = year + '-' + month + '-' + day + ' ' + hour;
                    return $window.moment(finalDate).format();
                }
                if (sd.property === 'competency') {
                    const date = value.split(' ')[0];
                    const month = date.split('/')[0];
                    const year = date[1];
                    const finalDate = month + '-' + year;
                    return $window.moment(finalDate).format();
                }

                if(sd.property === 'type' || sd.property === 'publishedTo') {
                        return value;
                }
            };
        }
        return service;
    }
})(window.angular, window.wijmo);
